class CardImageSlider extends HTMLElement {
  constructor() {
    super();
    this.positionIndex = 1
    this.images = JSON.parse(String(this.dataset.images).replaceAll(`'`,`"`))

    if (!Array.isArray(this.images)) return console.warn('[data-images] is not an array')

    this.totalImagesIndex = this.images.length - 1
    this.primaryImage = this.parentElement.querySelector('.image-primary')
    this.secondaryImage = this.querySelector('.grid-product__secondary-image').querySelector('img')

    this.prevButton = this.querySelector('.image-page-button--previous');
    this.nextButton = this.querySelector('.image-page-button--next');

  }

  connectedCallback() {
    if(!this.secondaryImage) return

    // show buttons as it's hidden by default
    this.querySelectorAll('.image-page-button').forEach(button => {
      button.style.display = ''
    })

    this.nextButton.addEventListener('click', this.handleNextButton.bind(this));
    this.prevButton.addEventListener('click', this.handlePrevButton.bind(this));
  }

  disconnectedCallback() {
    if(!this.secondaryImage) return

    // hide buttons
    this.querySelectorAll('.image-page-button').forEach(button => {
      button.style.display = 'none'
    })

    this.nextButton.removeEventListener('click', this.handleNextButton.bind(this));
    this.prevButton.removeEventListener('click', this.handlePrevButton.bind(this));
  }

  handleNextButton(event) {
    event.preventDefault()
    let primarySrc
    let secondarySrc

    // so we can see the new src
    this.primaryImage.srcset = ''
    this.secondaryImage.srcset = ''

    if (this.positionIndex >= this.totalImagesIndex) {
      this.positionIndex = 0
      secondarySrc = this.images[0]
      primarySrc = this.images[1]
    } else {
      const newIndex = this.positionIndex + 1

      this.positionIndex = newIndex
      secondarySrc = this.images[newIndex]
      primarySrc = this.images[newIndex - 1]
    }
    console.log('next',this.positionIndex )

    this.secondaryImage.src = secondarySrc
    this.primaryImage.src = primarySrc
  }

  handlePrevButton(event) {
    event.preventDefault()
    let primarySrc
    let secondarySrc

    // so we can see the new src
    this.primaryImage.srcset = ''
    this.secondaryImage.srcset = ''

    if (this.positionIndex <= this.totalImagesIndex && this.positionIndex > 0) {
      const newIndex = this.positionIndex - 1

      this.positionIndex = newIndex
      secondarySrc = this.images[newIndex]
      primarySrc = this.images[newIndex + 1]
    } else {
      const newIndex = this.totalImagesIndex

      this.positionIndex = newIndex
      secondarySrc = this.images[newIndex]
      primarySrc = this.images[0]
    }
    console.log('prev',this.positionIndex )
    this.secondaryImage.src = secondarySrc
    this.primaryImage.src = primarySrc
  }
}

if (!customElements.get('card-image-slider')) {
  customElements.define('card-image-slider', CardImageSlider);
}
